import {
  Equipment,
  EquipmentModelType,
  QueryEquipmentQuery,
  QueryEquipmentQueryVariables,
} from '__generated__/graphql';
import { EQUIPMENT_QUERY } from 'apollo/queries/equipment-queries';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { orderBy } from 'lodash';
import { NO_EQUIPMENT_ID } from '../../EquipmentClockFormPickerFormField/EquipmentClockFormPickerFormField';

export default function useEquipmentAddOnData() {
  const client = useGraphQLClient();

  const getEquipment = async (
    equipmentModelType: EquipmentModelType | null,
    categoryId: string | null,
    selectedId?: string
  ) => {
    try {
      const result = await client.request<QueryEquipmentQuery, QueryEquipmentQueryVariables>({
        document: EQUIPMENT_QUERY,
        variables: {
          first: 500,
          filter: {
            //filter out the previously selected equipment
            id: selectedId && !selectedId.includes(NO_EQUIPMENT_ID) ? { notEqual: selectedId } : undefined,
            model: {
              equipmentCategoryId: categoryId ? { equal: categoryId } : undefined,
              type: equipmentModelType ? { equal: equipmentModelType } : undefined,
            },
            deletedOn: { isNull: true },
          },
        },
      });

      const sortedData = orderBy(result.equipment, (e) => e.equipmentName.toLowerCase()) as Equipment[];

      return sortedData;
    } catch (error) {
      throw Error(`Error fetching equipment: ${error instanceof Error ? error.message : String(error)}`);
    }
  };
  return { getEquipment };
}
